var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreenshot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#025b64",
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,4.5 C18.325472,4.5 19.4100378,5.53153766 19.4946823,6.83562452 L19.5,7 L19.5,16.5 L21,16.5 C21.8284,16.5 22.5,17.1716 22.5,18 C22.5,18.7796706 21.9050879,19.4204457 21.1444558,19.4931332 L21,19.5 L19.5,19.5 L19.5,21 C19.5,21.8284 18.8284,22.5 18,22.5 C17.2203294,22.5 16.5795543,21.9050879 16.5068668,21.1444558 L16.5,21 L16.5,7.5 L9.5,7.5 L9.5,4.5 L17,4.5 Z M6,1.5 C6.82843,1.5 7.5,2.17157 7.5,3 L7.5,16.5 L14.5,16.5 L14.5,19.5 L7,19.5 C5.61929,19.5 4.5,18.3807 4.5,17 L4.5,7.5 L3,7.5 C2.17157,7.5 1.5,6.82843 1.5,6 C1.5,5.17157 2.17157,4.5 3,4.5 L4.5,4.5 L4.5,3 C4.5,2.17157 5.17157,1.5 6,1.5 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenshot);
export default __webpack_public_path__ + "static/media/screenshot.a0d8630edd287887875ac2bddfef8870.svg";
export { ForwardRef as ReactComponent };